module.exports = __webpack_public_path__ + "static/media/address_2.6ab82490.png";